import { logout, removeToken } from '../store/slice/authSlice';
import { persist } from '../store/store';
import masterCardLogo from '../assets/images/cardOrders/logo_mastercard.png';
import visaCardLogo from '../assets/images/cardOrders/logo_visa.png';
import amexCardLogo from '../assets/images/cardOrders/logo_amex.png';
import dinnersClubCardLogo from '../assets/images/cardOrders/logo_dinnersClub.png';
import jcbCardLogo from '../assets/images/cardOrders/logo_jcb.png';
import maestroCardLogo from '../assets/images/cardOrders/logo_maestro.png';
import troyCardLogo from '../assets/images/cardOrders/logo_troy.png';
import cardAkbankLogo from '../assets/images/banks/logo_akbank.png';
import cardAlbarakaLogo from '../assets/images/banks/logo_albaraka.png';
import cardAlternatifBankLogo from '../assets/images/banks/logo_alternatifbank.png';
import cardAnadoluBankLogo from '../assets/images/banks/logo_anadolubank.png';
import cardBankAsyaLogo from '../assets/images/banks/logo_bankasya.png';
import cardBurganBankLogo from '../assets/images/banks/logo_burganbank.png';
import cardDenizBankLogo from '../assets/images/banks/logo_denizbank.png';
import cardFinansBankLogo from '../assets/images/banks/logo_finansbank.png';
import cardHalkbankLogo from '../assets/images/banks/logo_halkbank.png';
import cardGarantiBBVALogo from '../assets/images/banks/logo_garantibbva.png';
import cardHsbcLogo from '../assets/images/banks/logo_hsbc.png';
import cardIngBankLogo from '../assets/images/banks/logo_ingbank.png';
import cardIsBankasiLogo from '../assets/images/banks/logo_isbankasi.png';
import cardKuveytTurkLogo from '../assets/images/banks/logo_kuveytturk.png';
import cardOdeaBankLogo from '../assets/images/banks/logo_odeabank.png';
import cardPttBankLogo from '../assets/images/banks/logo_pttbank.png';
import cardSekerBankLogo from '../assets/images/banks/logo_sekerbank.png';
import cardEmptyBankLogo from '../assets/images/banks/logo_empty_bank.png';
import cardTebLogo from '../assets/images/banks/logo_teb.png';
import cardTurkishBankLogo from '../assets/images/banks/logo_turkishbank.png';
import cardTurkiyeFinansLogo from '../assets/images/banks/logo_turkiyefinans.png';
import cardVakifBankLogo from '../assets/images/banks/logo_vakifbank.png';
import cardYapikrediLogo from '../assets/images/banks/logo_yapikredi.png';
import cardZiraatLogo from '../assets/images/banks/logo_ziraat.png';
import { Modal } from 'antd';
import { resetCurrentLoadBalance } from '../store/slice/balanceUploadSlice';
import { resetDetail } from '../store/slice/cardOrderDetailtsSlice';
import { isObject } from 'lodash';
import uniqBy from 'lodash/uniqBy';
import CustomText from '@src/components/Text';

export const objectEmptyCheck = (obj) => {
  return Object.keys(obj).length === 0 && obj.constructor === Object;
};

export const moneyFormat = (money, moneyIcon) => {
  const valueFormat = new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'TRY',
    currencyDisplay: 'code',
  }).format(money);

  if (moneyIcon) {
    return valueFormat?.replace('TRY', ' ₺')?.replaceAll(' ', '');
  } else {
    return valueFormat?.replace('TRY', '')?.replaceAll(' ', '');
  }
};

export const makeTableProperty = (obj) => {
  try {
    if (obj.hasOwnProperty('hasPrevious')) {
      const { data, isFailure, isSuccess, ...currentObj } = obj;
      return {
        data: {
          items: [...data],
          pagedProperty: {
            ...currentObj,
            totalCount: currentObj.totalItems,
          },
        },
        isFailure,
        isSuccess,
      };
    }
    return obj;
  } catch (e) {
    return obj;
  }
};
export const responseJsonIgnore = (obj) => {
  try {
    if (obj?.data) {
      if (Array.isArray(obj.data) || typeof obj.data === 'string') {
        return obj;
      } else {
        if (!obj.data) return obj;
        if (!isObject(obj.data)) return obj;
        const { insertTime, insertUserId, updateTime, updateUserId, ...currentObj } = obj.data;
        return {
          ...obj,
          data: {
            ...currentObj,
          },
        };
      }
    }
    return obj;
  } catch (e) {
    return obj;
  }
};

export const counterFormat = (counter) => {
  const minutes = counter?.minutes < 10 ? `0${counter?.minutes}` : counter?.minutes;
  const seconds = counter?.seconds < 10 ? `0${counter?.seconds}` : counter?.seconds;
  return ` ${minutes} : ${seconds} `;
};

export const persistLogin = async (dispatch, staticLogout) => {
  if (staticLogout) {
    await dispatch(removeToken());
  } else {
    //balance-upload sayfasındayken sipariş tipi seçip tutarlarda güncelleme yaptıktan sonra uygulamadan çıkış yapıldığında
    //aynı olduğu sayfada kalıp logine yönelmeme sorunu karşısında geçici çözüm olarak mevcut bakiye bilgisi state i sıfırlanmıştır.
    //balance-upload sayfasındaki durum card-orders sayfasında da cardList array i dolu olduğunda yaşanmaktadır. orda da bir sıfırlama işlemi yapılmıştır.
    await dispatch(resetCurrentLoadBalance());
    await dispatch(resetDetail());
    localStorage.removeItem('selectedCustomer');
    await dispatch(logout());
    await dispatch(removeToken());
  }
  Modal.destroyAll();
  await persist.purge();
  window?.location?.reload(true);
};

export const cardTypeIcon = (cardType) => {
  switch (cardType) {
    case 'Visa':
      return visaCardLogo;
    case 'Mastercard':
      return masterCardLogo;
    case 'maestro':
      return maestroCardLogo;
    case 'Amex':
      return amexCardLogo;
    case 'Troy':
      return troyCardLogo;
    case 'JCB':
      return jcbCardLogo;
    case 'DinersClub':
      return dinnersClubCardLogo;
    case 'Maestro':
      return maestroCardLogo;
    case 'Discover':
      return masterCardLogo;
    default:
      return masterCardLogo;
  }
};

export const bankCodeIcon = (bankCode) => {
  switch (bankCode) {
    case '010': // Ziraat Bankası
      return cardZiraatLogo;
    case '012': // Halk Bankası
      return cardHalkbankLogo;
    case '015': // Vakıfbank
      return cardVakifBankLogo;
    case '032': // TEB
      return cardTebLogo;
    case '046': // Akbank
      return cardAkbankLogo;
    case '059': // Şeker Bank
      return cardSekerBankLogo;
    case '062': // Garanti BBVA
      return cardGarantiBBVALogo;
    case '064': // İş Bankası
      return cardIsBankasiLogo;
    case '067': // YKB
      return cardYapikrediLogo;
    case '096': // Turkish Bank
      return cardTurkishBankLogo;
    case '099': // ING Bank
      return cardIngBankLogo;
    case '111': // Finans Bank
      return cardFinansBankLogo;
    case '123': // HSBC Bank
      return cardHsbcLogo;
    case '124': // Alternatif Bank
      return cardAlternatifBankLogo;
    case '125': // Burgan Bank
      return cardBurganBankLogo;
    case '134': // DenizBank
      return cardDenizBankLogo;
    case '135': // AnadoluBank
      return cardAnadoluBankLogo;
    case '146': // OdeaBank
      return cardOdeaBankLogo;
    case '203': // Albaraka
      return cardAlbarakaLogo;
    case '205': // KuveytTurk
      return cardKuveytTurkLogo;
    case '206': // Turkiye Finans
      return cardTurkiyeFinansLogo;
    case '208': // Bank Asya
      return cardBankAsyaLogo;
    case '6003': // PTT Bank
      return cardPttBankLogo;
    default:
      // default
      return cardEmptyBankLogo;
  }
};

export const cardNumberMask = (card) => {
  let hideNum = [];
  for (let i = 0; i < card?.length; i++) {
    if (i >= 4 && i < card?.length - 4) {
      hideNum.push('*');
    } else {
      hideNum.push(card[i]);
    }
  }
  return hideNum.join('');
};

// blob ile çalıştırılır
export const previewDownload = async (blob) => {
  const blobURL = URL.createObjectURL(blob);
  const iframe = document.createElement('iframe'); //load content in an iframe to print later
  document.body.appendChild(iframe);
  iframe.style.display = 'none';
  iframe.src = blobURL;
  iframe.onload = function () {
    setTimeout(function () {
      iframe.focus();
      iframe.contentWindow.print();
    }, 1);
  };
};

export const isGreaterMaximumLoadedAmount = (data) => {
  const controlValue = parseFloat(data?.controlValue?.replace(',', '.')) || 0;
  return data.price > controlValue || data.dailyPrice > controlValue;
};

/**
 * Picks between a Turkish and an English variant of a client-generated file name (Excel/PDF
 * exports built with js-file-download, not names the backend returns) based on the site's current
 * language. Reads localStorage directly (same storage key/format LanguageContext writes) instead
 * of taking a `language` argument, so callers - including download handlers defined once and
 * reused across renders - always get the language that's current at the moment of the click.
 */
export const getFileNameByLanguage = (turkishName, englishName) => {
  const language = window.localStorage.getItem('language')?.slice(1, -1);
  return language === 'en' ? englishName : turkishName;
};

export const turkishToLower = (string) => {
  let letters = { İ: 'i', I: 'ı', Ş: 'ş', Ğ: 'ğ', Ü: 'ü', Ö: 'ö', Ç: 'ç' };
  string = typeof string === 'string' ? string : String(string ?? '');
  string = string.replace(/(([İIŞĞÜÇÖ]))/g, function (letter) {
    return letters[letter];
  });
  return string.toLowerCase();
};

export const turkishToUpper = (string) => {
  let letters = { i: 'İ', ı: 'I', ş: 'Ş', ğ: 'Ğ', ü: 'Ü', ö: 'Ö', ç: 'Ç' };
  string = string.replace(/(([iışğüçö]))/g, function (letter) {
    return letters[letter];
  });
  return string.toUpperCase();
};

export const stringCut = (limit, string) => {
  return string.length > limit ? string.substring(0, limit) + ' ...' : string;
};

export const handleAuthStatus = (list, label) => {
  let item = list?.find((item) => item?.label === label);
  return item?.isDisabled;
};

export function arrayMoveMutable(array, fromIndex, toIndex) {
  const startIndex = fromIndex < 0 ? array.length + fromIndex : fromIndex;

  if (startIndex >= 0 && startIndex < array.length) {
    const endIndex = toIndex < 0 ? array.length + toIndex : toIndex;

    const [item] = array.splice(fromIndex, 1);
    array.splice(endIndex, 0, item);
  }
}

export function arrayMoveImmutable(array, fromIndex, toIndex) {
  array = [...array];
  arrayMoveMutable(array, fromIndex, toIndex);
  return array;
}
export function isCreditCardUser(customerVou) {
  return customerVou?.pamId === 4 && customerVou?.patId === 2;
}

export const passwordRegex = [
  {
    text: <CustomText t="password.minLength" />,
    regExp: '(?=^.{12,}$)',
  },
  {
    text: <CustomText t="password.minNumber" />,
    regExp: '(?=.*[0-9]).*',
  },
  {
    text: <CustomText t="password.minSpecialChar" />,
    regExp: '(?=.*[.,:;?!*\\@#$&*%_+]+)',
  },
  {
    text: <CustomText t="password.minUpperCase" />,
    regExp: '(?=.*[A-ZĞÜŞİÖÇ])',
  },
  {
    text: <CustomText t="password.minLowerCase" />,
    regExp: '(?=.*[a-zğüşıöç])',
  },
];

export const ExcelErrorMessageWithGroup = (errorMessages) => {
  const allMessages = errorMessages?.map((message) => {
    const data = message.errorMessage;
    if (data.includes('mükerrerdir') && data.includes('Kart numarası')) {
      return 'Kart numarası mükerrerdir.';
    }
    if (data.includes('mükerrerdir') && data.includes('Referans numarası')) {
      return 'Referans numarası mükerrerdir.';
    }
    const pattern = /Satır \d+ - (.+)/;
    const match = data?.match(pattern);
    if (match) {
      return match[1];
    }
    return data;
  });
  return uniqBy(allMessages, (item) => item);
};

export function deepMergeWithSpread(obj1, obj2) {
  const result = { ...obj1 };

  for (let key in obj2) {
    if (obj2.hasOwnProperty(key)) {
      if (obj2[key] instanceof Object && obj1[key] instanceof Object) {
        result[key] = deepMergeWithSpread(obj1[key], obj2[key]);
      } else {
        result[key] = obj2[key];
      }
    }
  }

  return result;
}

export const Wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const DeleteAllCache = async () => {
  const allSessionKeys = [...Object.keys(window.localStorage)].filter((key) =>
    key.startsWith('axios-cache:'),
  );
  for await (const sessionKey of allSessionKeys) {
    localStorage.removeItem(sessionKey);
  }
};

export const dataLayer = (evt, evt_category, evt_action) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: evt,
    eventCategory: evt_category,
    eventAction: evt_action,
  });
};

export const formatPlate = (plate) => {
  if (!plate || typeof plate !== 'string') {
    return '';
  }

  let formattedPlate = plate.replace(/(\d{2})([a-zA-Z]+)(\d+)/, '$1 $2 $3');
  return formattedPlate.replace(/\s+/g, ' ').trim().toUpperCase();
};

export const formatDate = (dateStr) => {
  const [day, month, year] = dateStr.split('.');
  const date = new Date(`${year}-${month}-${day}`);

  return new Intl.DateTimeFormat('tr-TR', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  }).format(date);
};

export const formatPhoneNumber = (phone) => {
  // Tüm boşluk ve özel karakterleri temizle
  const cleaned = phone?.replace(/\D/g, '');

  // Formatla
  if (cleaned.length === 12 && cleaned.startsWith('90')) {
    const country = `+${cleaned.slice(0, 2)}`;
    const part1 = `(${cleaned.slice(2, 5)})`;
    const part2 = cleaned.slice(5, 8);
    const part3 = cleaned.slice(8, 10);
    const part4 = cleaned.slice(10, 12);
    return `${country} ${part1} ${part2} ${part3} ${part4}`;
  }

  return phone; // Format uygun değilse dokunma
};
